// extracted by mini-css-extract-plugin
export default {"title":"pilih-asisten-pembeli_title__BZUUU","prefix":"pilih-asisten-pembeli_prefix__Ogj8S","name":"pilih-asisten-pembeli_name__7p8mL"};